import React, {Component} from 'react';

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Field, reduxForm } from 'redux-form';
import ReactDOM from 'react-dom';
import { DefaultRegionCode } from '../../localeAssets';
import { InputWithErrors, InputDate, InputPhoneNumber  } from '../../lib/forms';
import InputAddress from '../../lib/forms/InputAddress';
import { api } from '../../services/redux-beesConfig';
import isEmpty from 'lodash/isEmpty';
import { AddressInfo } from '.';
import apiFormatDate from '../../services/setTheDateToTheApiFormat';

class EditInfoView extends Component{
  constructor() {
    super();
    this.state = {
    };
  }
  componentDidMount(){
    const element = ReactDOM.findDOMNode(this);
      if (element != null) {
        window.scrollTo(0, this.scrollPosition)
      }
  }
  render() {
    const { translate, handleSubmit, cancel, user } = this.props;
    if (!isEmpty(user)){
      return (
        <div className="col-lg-12">
          <div className="card card-section" id="info">
            <div className="card-block">
              <div className="card-title">
                <h3>{translate('contact-details')}</h3>
              </div>
              <form className="form-line edit" method="post" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>{translate('first-name')}</label>
                      <div>
                        {user.fname}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>{translate("last-name")}</label>
                      <div>
                        {user.lname}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>{translate('birth-date')}</label>
                      <Field name="dob"  className="form-control"  component={InputDate} type="date"   initvalue={user.dob} />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label>{(translate("phone"))}</label>
                      <Field name="tel" component={InputPhoneNumber} defaultCountry={DefaultRegionCode()} className="form-control" type="tel" initvalue={user.tel} />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 push-lg-4">
                    <div className="form-group">
                      <label>{translate("other-phone")}</label>
                      <Field name="tel2"  component={InputPhoneNumber} defaultCountry={DefaultRegionCode()}  className="form-control" type="tel" initvalue={user.tel2}/>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 pull-lg-4">
                    <div className="form-group">
                      <label>email</label>
                      <Field name="email" component={InputWithErrors}  className="form-control" type="email" initvalue={user.email}/>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4"></div>
                </div>
                <div className="row justify-content-end row-btn">
                  <div className="col-6 col-md-3">
                    <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel()} >{translate('cancel')}</button>
                  </div>
                  <div className="col-6 col-md-3">
                    <button className="btn btn-block btn-form btn-submit" type="submit" ui-sref="personal-information" >{translate('save')}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div></div>
    );
  }
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch({
        type: 'SET_FLASH_MESSAGE',
        message: message,
        success: success
      });
    },
  };
};

EditInfoView = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(EditInfoView);

const EditInfoFormViewRedux = reduxForm({
  form: 'EditInfo',
  enableReinitialize: true,
})(EditInfoView)

class EditInfoFormHandler extends Component {

  handleSubmit(values) {
    const { currentLanguage, setFlashMessage, translate, history } = this.props;
    if (isEmpty(values)) {
      history.goBack();
      return ;
    }
    const valusOb = values.dob ? {tel:values.tel, tel2:values.tel2, dob:apiFormatDate(values.dob), email:values.email } : {tel:values.tel, tel2:values.tel2, email:values.email }
    api.updateUser({ locale: currentLanguage, id: this.props.userID }, valusOb)
    .then((res) => {
      setFlashMessage(`${translate('changes-saved-successfully')}`, true)
      history.goBack();
    })
    }
    cancel(values) {
      const { history } = this.props;
      history.goBack();
    }


  render() {

    return (
      <div>
        <EditInfoFormViewRedux onSubmit={this.handleSubmit.bind(this)} cancel={this.cancel.bind(this)} user={this.props.user} />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
    userID: state.User.id,

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  }
}

EditInfoFormHandler = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInfoFormHandler);

EditInfoFormHandler = withRouter(EditInfoFormHandler);
export default EditInfoFormHandler;



// WEBPACK FOOTER //
// ./src/components/InfoPerson/EditInfo.js